import BigNumber from "bignumber.js";
import { InitPage } from "../index";

class EpcSettingProfileForm {
    item_start_bit: number
    serial_start_bit: number
    pallet_start_bit: number
    validatorRequest: number = 0

    constructor(item_start_bit: number, serial_start_bit: number, pallet_start_bit: number) {
        this.item_start_bit = item_start_bit;
        this.serial_start_bit = serial_start_bit;
        this.pallet_start_bit = pallet_start_bit;

        this.init();
        this.companyPrefixHandler();
        this.epcValidatorHandler();
        setTimeout(this.render, 0);
        this.formValidator();
    }

    init() {
        this.slider(this.epcLength());

        $('input:radio[name="epc_setting_profile[profile_type]"]').on("change", (e: any) => {
            this.slider(this.epcLength());
            this.validateEpc($('input:text[id="epc_validator"]').val().toString());
        });
        $("#epc_setting_profile_default").on("click", (event: any) => event.target.checked ? $("#epc_setting_profile_enabled").prop("checked", true) : null);

        const prefix = new BigNumber($("#epc_setting_profile_epc_write_prefix").val().toString(), 2);
        $('#epc_write_prefix').text($("#epc_setting_profile_epc_write_prefix").val().toString());
        $('input:text[id="company_decimal"]').val(prefix.toString());
        $('input:text[id="company_hexadecimal"]').val(prefix.toString(16).toUpperCase());
    }

    slider(max: number) {
        $("#slider-range").slider({
            range: true,
            step: 1,
            min: 0,
            max,
            values: [this.item_start_bit, this.serial_start_bit],
            classes: { "ui-slider": "ui-corner-all" },
            create: this.render,
            change: this.render
        });
    }

    epcLength() {
        return $('input:radio[name="epc_setting_profile[profile_type]"]:checked').val() === "simple" ? 96 : 128;
    }

    companyPrefixHandler() {
        $('input:text[id="company_decimal"]').on("keypress", (event: any) => !event.key.match(/[0-9v]/g) ? event.preventDefault() : null);
        $('input:text[id="company_hexadecimal"]').on("keypress", (event: any) => !event.key.match(/[0-9A-Fa-fv]/g) ? event.preventDefault() : null);

        $('input:text[id="company_decimal"]').on("keyup", (event: any) => {
            event.target.value = event.target.value.match(/[0-9]/g).join('').toUpperCase();
            const value = new BigNumber(event.target.value) || "";
            $('input:text[id="company_hexadecimal"]').val(value.toString(16).toUpperCase());
            $('#epc_write_prefix').text(value.toString(2));
            $('input:hidden[id="epc_setting_profile_epc_write_prefix"]').val(value.toString(2));
            this.render();
        });

        $('input:text[id="company_hexadecimal"]').on("keyup", (event: any) => {
            event.target.value = event.target.value.match(/[0-9A-Fa-f]/g).join('').toUpperCase();
            const value = new BigNumber(event.target.value, 16) || "";
            $('input:text[id="company_decimal"]').val(value.toString());
            $('#epc_write_prefix').text(value.toString(2));
            $('input:hidden[id="epc_setting_profile_epc_write_prefix"]').val(value.toString(2));
            this.render();
        });
    }

    render() {
        const range = $("#slider-range");
        const [lowerBound, upperBound] = range.slider("values");
        const max = range.slider("option", "max");
        const prefixBits = lowerBound;
        const itemBits = upperBound - lowerBound;
        const serialBits = max - upperBound;

        $('input:hidden[id="epc_setting_profile_item_number_start_bit"]').val(lowerBound);
        $('input:hidden[id="epc_setting_profile_item_number_total_bits"]').val(itemBits);
        $('input:hidden[id="epc_setting_profile_serial_number_start_bit"]').val(upperBound);
        $('input:hidden[id="epc_setting_profile_serial_number_total_bits"]').val(serialBits);

        $("#prefix_bits").text(`${prefixBits} bits`);
        $("#item_bits").text(`${itemBits} bits`);
        $("#serial_bits").text(`${serialBits} bits`);

        const decimalValue = new BigNumber($("#company_decimal").val().toString());
        const fromValue = new BigNumber(2).exponentiatedBy(prefixBits -1);
        const toValue = new BigNumber(2).exponentiatedBy(prefixBits).minus(1);
        if (decimalValue.isGreaterThan(toValue) || decimalValue.isLessThan(fromValue)) {
            $('#form-submit').prop('disabled', 'disabled')
            $("#company_error").text(`Decimal should be between ${fromValue} and ${toValue} OR Hex should be between ${fromValue.toString(16).toUpperCase()} and ${toValue.toString(16).toUpperCase()}`);
            $("#sample_epc").text("");
            $("#zpl").text("");
        } else {
            $('#form-submit').prop('disabled', '')
            $("#company_error").text("");
            $("#sample_epc").text(
                new BigNumber(`${$('#epc_write_prefix').text()}${new Array(itemBits).join('0')}1${new Array(serialBits).join('0')}1`, 2).toString(16).toUpperCase()
            );
            $('#zpl').text(
                `^RB${max},${prefixBits},${itemBits},${serialBits}^FS ^RFW,E^FS ^RFW,E^FD${$('input:hidden[id="epc_setting_profile_epc_write_prefix"]').val()},${new Array(itemBits).join('0')}1,${new Array(serialBits).join('0')}1^FS`
            );
        }

        $("#largest_asset_number").text(new BigNumber(2).exponentiatedBy(itemBits).minus(1).toString());
        $("#largest_serial_number").text(new BigNumber(2).exponentiatedBy(serialBits).minus(1).toString());
    }

    epcValidatorHandler() {
        $('input:text[id="epc_validator"]').on("keypress", (event: any) => !event.key.match(/[0-9A-Fa-fv]/g) ? event.preventDefault() : null);
        $('input:text[id="epc_validator"]').on("input", (event: any) => {
            event.target.value = (event.target.value.match(/[0-9A-Fa-f]/g) || []).join('').toUpperCase();
            this.validateEpc(event.target.value);
        });
    }

    validateEpc(epc: string) {
        this.validatorRequest += 1;
        const request = this.validatorRequest;
        const sgtin = this.isSgtin();

        $('#epc_prefix_header').text(sgtin ? 'Company Prefix' : 'Prefix');
        $('#epc_asset_header').text(sgtin ? 'GTIN' : 'Asset Number');

        if (epc.length !== this.validatorHexLength()) {
            this.renderValidatorResult(epc.length === 0 ? '' : `EPC must be ${this.validatorHexLength()} hexadecimal characters`);
            return;
        }

        if (!sgtin) {
            this.renderSimpleEpc(epc);
            return;
        }

        $.ajax({
            url: $('input:text[id="epc_validator"]').data('validate-url'),
            method: 'GET',
            data: { epc },
            dataType: 'json',
            success: (response: any) => {
                if (request !== this.validatorRequest) { return; }

                this.renderValidatorResult(
                    response.valid ? '' : response.error,
                    response.company_prefix,
                    response.item_number,
                    response.serial_number
                );
            },
            error: () => {
                if (request !== this.validatorRequest) { return; }

                this.renderValidatorResult('Not able to decode this EPC, please try again later');
            }
        });
    }

    renderSimpleEpc(epc: string) {
        const length = this.epcLength();
        const binary = new BigNumber(epc, 16).toString(2);
        const value = new Array(length - binary.length + 1).join('0') + binary;
        const prefix = new BigNumber(value.substring(0, this.item_start_bit), 2).toString();
        const asset = new BigNumber(value.substring(this.item_start_bit, this.serial_start_bit), 2).toString();
        const padding = parseInt($('input[id="epc_setting_profile_item_number_padding"]').val().toString(), 10) || 0;
        const serial = new BigNumber(value.substring(this.serial_start_bit, this.pallet_start_bit), 2).toString();
        const serialLength = new BigNumber(2).exponentiatedBy(length - this.serial_start_bit - 1).minus(1).toString().length;

        this.renderValidatorResult(
            '',
            prefix,
            this.padZeros(asset, padding),
            this.padZeros(serial, serialLength)
        );
    }

    renderValidatorResult(error: string, prefix: string = '', asset: string = '', serial: string = '') {
        $('#epc_validator_error').text(error);
        $('#epc_prefix').text(error ? '' : prefix);
        $('#epc_asset').text(error ? '' : asset);
        $('#epc_serial').text(error ? '' : serial);
    }

    isSgtin() {
        return $('input:radio[name="epc_setting_profile[profile_type]"]:checked').val() === "sgtin";
    }

    validatorHexLength() {
        return 96 / 4;
    }

    padZeros(value: string, length: number) {
        return value.length >= length ? value : new Array(length - value.length + 1).join('0') + value;
    }

    formValidator() {
        this.setOptionalRequired($('#epc_setting_profile_encode_prefix_in_item_number').is(':checked'));

        $('#epc_setting_profile_encode_prefix_in_item_number').on('change', (event: any) =>  this.setOptionalRequired(event.target.checked));

        $('#epc_setting_form').on("submit", (event: any) => {
           let prevent = false;

           prevent = this.hasError('input[id="company_decimal"]') || prevent;
           prevent = this.hasError('input[id="company_hexadecimal"]') || prevent;
           prevent = this.hasError('input[id="epc_setting_profile_epc_allowed_prefixes"]') || prevent;
           prevent = this.hasError('input[id="epc_setting_profile_name"]') || prevent;
           prevent = this.hasError('input[id="epc_setting_profile_item_number_padding"]') || prevent;

           if ($('input:checked[id="epc_setting_profile_encode_prefix_in_item_number"]').val()) {
               prevent = this.hasError('input[id="epc_setting_profile_item_prefix_start_bit"]') || prevent;
               prevent = this.hasError('input[id="epc_setting_profile_item_prefix_total_bits"]') || prevent;
               prevent = this.hasError('input[id="epc_setting_profile_item_number_middle_padding"]') || prevent;
           }

           if (prevent) {
               event.preventDefault();
               setTimeout(() => $('#form-submit').removeAttr("disabled"), 1000)
           }
       });
    }

    hasError(item: String) {
        const elm = $(item);
        const empty = elm.val().toString().trim() == ''
        elm.css('border', `1px solid ${empty ? 'red' : '#ccc'}`)
        return empty;
    }

    setOptionalRequired(required: any) {
        $('input[id="epc_setting_profile_item_prefix_start_bit"]').attr('required', required);
        $('input[id="epc_setting_profile_item_prefix_total_bits"]').attr('required', required);
        $('input[id="epc_setting_profile_item_number_middle_padding"]').attr('required', required);
    }
}

export function LoadPage() {
  InitPage("epc_setting_profiles new edit", () => 
    new EpcSettingProfileForm(
      parseInt(($('input:hidden[id="epc_setting_profile_item_number_start_bit"]').val() || 20).toString()),
      parseInt(($('input:hidden[id="epc_setting_profile_serial_number_start_bit"]').val() || 58).toString()),
      parseInt(($('#epc_setting_profile_pallet_start_bit').val() || 96).toString())
    )
  );
}